document.addEventListener("DOMContentLoaded", function () {

  var acc = document.getElementsByClassName("cst-accordion");

  var i;

  for (i = 0; i < acc.length; i++) {

    acc[i].addEventListener("click", function () {

      this.classList.toggle("cst-active");

      var panel = this.nextElementSibling;

      if (panel.style.maxHeight) {

        panel.style.maxHeight = null;

      } else {

        panel.style.maxHeight = panel.scrollHeight + "px";

      }

    });

  }

});